export function SignReadyIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fill="currentColor"
        fillOpacity="0.54"
        d="M5.96214 11.6473L5.00001 12.6095L1.52861 9.13807C1.26826 8.87772 1.26826 8.45561 1.52861 8.19526C1.78896 7.93491 2.21107 7.93491 2.47141 8.19526L5.00001 10.7239L5.0166 10.7073C5.29919 10.9899 5.61341 11.3022 5.96214 11.6473Z"
      />
      <path
        fill="currentColor"
        fillOpacity="0.54"
        d="M6.80475 8.91912L11.5286 4.19526C11.789 3.93491 12.2111 3.93491 12.4714 4.19526C12.6339 4.35774 12.695 4.58323 12.6547 4.79307L7.66668 9.78105L6.80475 8.91912Z"
      />
      <path
        fill="currentColor"
        fillOpacity="0.54"
        d="M7.66668 12.6095L15.1381 5.13807C15.3659 4.91027 15.3944 4.55861 15.2235 4.29984C15.1991 4.26288 15.1706 4.22781 15.1381 4.19526C14.8777 3.93491 14.4556 3.93491 14.1953 4.19526L7.66668 10.7239L5.13808 8.19526C4.87773 7.93491 4.45562 7.93491 4.19527 8.19526C3.93492 8.45561 3.93492 8.87772 4.19527 9.13807L7.66668 12.6095Z"
      />
    </svg>
  );
}
